<template>
  <div class="logo-tile" :style="{ '--accent': accent }">
    <span>{{ letter }}</span>
    <img
        v-if="showImage"
        :src="tool.iconUrl"
        alt=""
        loading="lazy"
        @error="$emit('fail', iconKey)"
    >
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  tool: { type: Object, required: true },
  accent: { type: String, default: '#2F5BFF' },
  failed: { type: Object, default: () => ({}) }
})

defineEmits(['fail'])

const iconKey = computed(() => props.tool.kind === 'AIP' ? props.tool.pluginKey : props.tool.productCode)
const letter = computed(() => String(props.tool.name || '?').trim().slice(0, 1))
const showImage = computed(() => Boolean(props.tool.iconUrl) && !props.failed[iconKey.value])
</script>

<style scoped>
.logo-tile {
  position: relative;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  overflow: hidden;
  border: 1px solid var(--line, #e6eaf2);
  border-radius: 11px;
  background: linear-gradient(135deg, #fff, var(--surface-2, #F2F4F8));
}

.logo-tile span {
  color: var(--accent);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: -.04em;
}

.logo-tile img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 4px;
  background: #fff;
  object-fit: contain;
}
</style>
